<template>
  <div class="homeleft">
    <div class="listai">
       <h1>
        全国及各省姓名重名查询接口汇总
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年1月1日</Col>
      </Row>
      <p>这是一篇满满的干货 ,一定要转发给身边的朋友,并且一定要收藏的一篇文章,我们收集了全国的重名查询的网址,以及查询方式,帮助你查询自己的名字在全国有多少人,还可以帮朋友查、帮亲戚查重名。</p>  
      <p></p>
      <h3 style="text-align:center;">全国</h3>
      <p></p>
      <div class="contentImg">
        <img src="@/assets/quanguo.jpg" />
      </div>
      <p style="text-align:center;">全国重名查询接口：https://zwfw.mps.gov.cn/searchWork.html </p>
      <p style="text-align:center;">查询条件：需要要注册，并且一个账号每天只能查询十次；</p>
      <p></p>
      <h3 style="text-align:center;">北京市</h3>
      <p></p>
      <!-- <div class="contentImg">
        <img src="@/assets/beijing.jpg" />
      </div> -->
      <p style="text-align:center;">北京市重名查询接口：https://gaj.beijing.gov.cn/rkgl/reserve/checkNameSexNum </p>
      <p style="text-align:center;">查询条件：不需要注册，只需验证码、分男女</p>
      <p></p>
      <h3 style="text-align:center;">上海市</h3>
      <p></p>
      <p style="text-align:center;">上海市重名查询接口：https://rkcs.gaj.sh.gov.cn/rkbyw/xsrcm/queryReq/0 </p>
      <p style="text-align:center;">查询条件：不需要注册，不需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">重庆市</h3>
      <p></p>
      <p style="text-align:center;">重庆市重名查询接口：https://wsga.gaj.cq.gov.cn/webchat/#/name </p>
      <p style="text-align:center;">查询条件：不需要注册，不需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">河南省</h3>
      <p></p>
      <p style="text-align:center;">河南省重名查询接口：http://bsdt.henanga.gov.cn/MainPages/ChaXunZhongXin/SameNameQuery </p>
      <p style="text-align:center;">查询条件：不需要注册，需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">黑龙江省</h3>
      <p></p>
      <p style="text-align:center;">黑龙江省重名查询接口：http://gafw.hljga.gov.cn/wyc.do?method=Show </p>
      <p style="text-align:center;">查询条件：不需要注册，需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">湖南省</h3>
      <p></p>
      <p style="text-align:center;">湖南省重名查询接口：https://fwpt.hnga.gov.cn/weixin/#/name </p>
      <p style="text-align:center;">查询条件：不需要注册，不需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">安徽省</h3>
      <p></p>
      <p style="text-align:center;">安徽省重名查询接口：http://www.ahga.gov.cn:8087/was2/was/hall/V1/jsp/st/cyc.jsp?type=hz&flag=2#ewt </p>
      <p style="text-align:center;">查询条件：不需要注册，需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">山东省</h3>
      <p></p>
      <p style="text-align:center;">山东省重名查询接口：https://www.sdmsjw.gov.cn/populationclient/search.shtml </p>
      <p style="text-align:center;">查询条件：不需要注册，需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">江苏省</h3>
      <p></p>
      <p style="text-align:center;">江苏省重名查询接口：http://www.wjw.jsga.gov.cn/cname/index </p>
      <p style="text-align:center;">查询条件：不需要注册，需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">广西</h3>
      <p></p>
      <p style="text-align:center;">广西重名查询接口：http://gafw.gat.gxzf.gov.cn/was/hall/V1/jsp/st/cyc.jsp?type=hz&flag=2#ewt </p>
      <p style="text-align:center;">查询条件：不需要注册，需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">甘肃省</h3>
      <p></p>
      <p style="text-align:center;">甘肃省重名查询接口：http://wx.gat.gansu.gov.cn/f/mp/s_10012/h_10172 </p>
      <p style="text-align:center;">查询条件：不需要注册，需验证码、分男女、需要手机号</p>
      <p></p>
      <h3 style="text-align:center;">吉林省</h3>
      <p></p>
      <p style="text-align:center;">吉林省重名查询接口：http://gafw.jl.gov.cn/MainPages/ChaXunZhongXin/DuplicateQuery </p>
      <p style="text-align:center;">查询条件：需要注册，需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">贵州省</h3>
      <p></p>
      <p style="text-align:center;">贵州省重名查询接口：https://zwfw.gzga.gov.cn/wechat/?sharer_username=gh_8cb0563d072a&scene=126&clicktime=1558424165#/repeat-name-query </p>
      <p style="text-align:center;">查询条件：不需要注册，不需验证码、分男女</p>
      <p></p>
      <h3 style="text-align:center;">广东省</h3>
      <p></p>
      <p style="text-align:center;">广东省重名查询接口：http://gdzaj.gd.gov.cn/gdza/web/xsecx/xseqmcx.ignore?type=cmcx</p>
      <p style="text-align:center;">查询条件：不需要注册，不需验证码、分男女</p>
      <p></p>
      <h3 style="text-align:center;">四川省</h3>
      <p></p>
      <p style="text-align:center;">四川省重名查询接口：http://scgazwfw.sczwfw.gov.cn/?convenientService=xinshenger</p>
      <p style="text-align:center;">查询条件：不需要注册，不需验证码、分男女</p>
      <p></p>
      <h3 style="text-align:center;">宁夏</h3>
      <p></p>
      <p style="text-align:center;">宁夏重名查询接口：https://zwfw.gat.nx.gov.cn/wechat/#/repeat-name-query</p>
      <p style="text-align:center;">查询条件：不需要注册，不需验证码、不分男女</p>
      <p></p>
      <h3 style="text-align:center;">全国</h3>
      <p></p>
      <div class="contentImg">
        <img src="@/assets/quanguo.jpg" />
      </div>
      <p style="text-align:center;">全国重名查询接口：https://zwfw.mps.gov.cn/searchWork.html</p>
      <p style="text-align:center;">查询条件：需要要注册，并且一个账号每天只能查询十次；</p>
      <p>本文属姓名图谱整理，图片来自网站截图，由于部分省份还未开放，目前没有提供查询接口，后期完善请关注公众号：姓名图谱；</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .contentImg {
      text-align: center;
      img {
        width: 600px;
      }
      @media screen and(max-width:1200px) {
        img {
          width: 300px;
        }
      }
    }
  .listai {
    @media screen and(max-width:1200px) {
      padding: 0px;
    }
    padding: 16px;
    h1 {
      margin: 30px 0;
      text-align: center;
      @media screen and(max-width:1200px) {
        margin: 10px 0;
      }
    }
    h3 {
      color: #00d2a5;
      // text-align: center;
    }
    h4 {
      font-size: 16px;
      // text-indent: 8px;
    }
    h5 {
      font-size: 15px;
      text-indent: 14px;
    }
    .titleTime {
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
      word-wrap:break-word;
    }

  }
}
</style>
